var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBatteryCharging = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16634 11H2.49967C2.05765 11 1.63372 10.8244 1.32116 10.5118C1.0086 10.1993 0.833008 9.77536 0.833008 9.33333V2.66667C0.833008 2.22464 1.0086 1.80072 1.32116 1.48816C1.63372 1.17559 2.05765 1 2.49967 1H5.15801M12.4997 1H14.1663C14.6084 1 15.0323 1.17559 15.3449 1.48816C15.6574 1.80072 15.833 2.22464 15.833 2.66667V9.33333C15.833 9.77536 15.6574 10.1993 15.3449 10.5118C15.0323 10.8244 14.6084 11 14.1663 11H11.508M19.1663 6.83333V5.16667M9.16634 1L5.83301 6H10.833L7.49967 11",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBatteryCharging, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/battery-charging.2bacc822.svg";
export { ForwardRef as ReactComponent };